/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import { HomeIcon, UsersIcon } from "@heroicons/react/24/outline";
import { BookText, UserCircleIcon } from "lucide-react";
import Link from "next/link";

const AdminBottomNavigation = () => {
  const [activeItem, setActiveItem] = useState('Home');
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  if (!isMobile) return null; // Only show on mobile screens

  return (
    <div className="fixed z-50 bottom-0 left-0 w-full bg-gradient-to-r from-purple-50 to-indigo-50 border-t border-purple-200 shadow-lg">
      <div className="flex justify-around py-1.5">
        <NavItem 
          icon={<HomeIcon className="w-6 h-6" />}
          activeIcon={<HomeIcon className="w-6 h-6 text-purple-700" />}
          label="Home"
          link={'home'}
          isActive={activeItem === 'Home'}
          onClick={() => setActiveItem('Home')}
        />
        <NavItem 
          icon={<UsersIcon className="w-6 h-6" />}
          activeIcon={<UsersIcon className="w-6 h-6 text-purple-700" />}
          label="Users"
          link={'users'}
          isActive={activeItem === 'Users'}
          onClick={() => setActiveItem('Users')}
        />
        <NavItem 
          icon={<BookText className="w-6 h-6" />}
          activeIcon={<BookText className="w-6 h-6 text-purple-700" />}
          label="Blogs"
          link={'view-blogs'}
          isActive={activeItem === 'Blogs'}
          onClick={() => setActiveItem('Blogs')}
        />
        <NavItem 
          icon={<UserCircleIcon className="w-6 h-6" />}
          activeIcon={<UserCircleIcon className="w-6 h-6 text-purple-700" />}
          label="Profile"
          link={'profile-page'}
          isActive={activeItem === 'Profile'}
          onClick={() => setActiveItem('Profile')}
        />
      </div>
    </div>
  );
};

const NavItem = ({ icon, activeIcon, label, link, isActive, onClick }) => (
  <Link href={link} passHref>
    <button 
      type='button' 
      onClick={onClick}
      className={`flex flex-col items-center justify-center w-full p-2 rounded-lg transition-all duration-200 ${
        isActive 
          ? 'bg-white text-purple-700 shadow-sm transform -translate-y-1' 
          : 'text-gray-600 hover:text-purple-800'
      }`}
    >
      <div className={`p-1 rounded-full ${isActive ? 'bg-purple-100' : ''}`}>
        {isActive ? activeIcon : icon}
      </div>
      <span className={`text-xs mt-0.5 ${isActive ? 'font-semibold' : 'font-medium'}`}>
        {label}
      </span>
    </button>
  </Link>
);

export default AdminBottomNavigation;